<template>
  <div class="page content-container">
    <title-with-breadcrumbs
      :title="translationSubNav | translate | capitalize"
    ></title-with-breadcrumbs>
    <product-grid></product-grid>
  </div>
</template>

<script>
import TitleWithBreadcrumbs from "../components/atoms/title-with-breadcrumbs.vue";
import ProductGrid from "../components/molecules/product-grid.vue";

export default {
  name: "CategoryOverview",
  components: {
    TitleWithBreadcrumbs,
    ProductGrid
  },
  computed: {
    translationSubNav() {
      return this.getSubNavItem
        ? `filter.type.${this.getSubNavItem}`
        : "filter.title.overview";
    }
  },
  async mounted() {
    await this.getSubNavs;
  },
  watch: {
    $route(to) {
      if (to.name !== "ProductPage") {
        this.resetFilters();
        this.setSelectOptions();
      }
      this.loadFilterResults();
      this.getSubNavs;
    }
  }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
.page {
  margin-top: $m-s;
}

.filter-container {
  margin-bottom: $m-m;
  button {
    float: right;
    padding: 0.25rem;
    display: flex;
    align-items: center;
    box-shadow: none;

    span {
      font-size: $font-sm;
      margin-left: 0.5rem;
    }
  }

  .icon-container {
    margin-top: 17px;
    width: 34px;
    height: 34px;
    border-radius: 12px;
    background-color: $gyra-grey-dark;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.filter-toggle {
  cursor: pointer;
  font-size: 34px;
  color: white;
}

h3 {
  font-size: 24px;
  font-weight: bold;
  @media (min-width: 800px) {
    font-size: 32px;
  }
}

.products {
  width: 100%;
}

.content-grid {
  display: grid;
  grid-gap: 2rem;
  justify-items: center;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  @media (min-width: $breakpoint-lg) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: $breakpoint-xl) {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .product-card {
    margin: 0;
    width: 100%;
    min-width: unset;

    .image {
      @media (max-width: $breakpoint-sm) {
        height: 12rem;
      }
    }
  }
}

.nothing-found {
  display: flex;
  justify-content: center;
  margin-top: 60px;
  font-weight: 400;
  font-size: 24px;
  text-align: center;
}

.apply-button {
  display: flex;
  align-self: center;
  width: 50%;
  border: 1px solid $gyra-salmon;
  border-radius: 10px;
  margin-top: 10px;
  height: 40px;
  align-items: center;
  justify-content: center;
  font-size: 1em;
  color: $gyra-salmon;
  cursor: pointer;
}

.main {
  display: flex;
  flex-direction: row;
}

.categories {
  height: auto;
  flex-direction: column;
  margin-right: 3rem;
  display: none;

  @media (min-width: $breakpoint-md) {
    display: flex;
  }

  .category-container {
    width: 10rem;
    margin-bottom: 0.5rem;
    transition: all 0.3s ease-in-out;
    padding-bottom: 0.25rem;
    cursor: pointer;
    position: relative;
    display: flex;
    flex-direction: column;

    &::after {
      content: "";
      height: 2px;
      width: 100%;
      background-color: $brand-gray-light;
      display: block;
      position: absolute;
      top: 2.5rem;
    }

    span {
      padding: 0.5rem 0;
    }

    .sub-category {
      height: 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      transition: all 0.3s ease-in-out;

      &.open {
        height: 100%;
        margin-top: 1rem;
      }

      span {
        margin-left: 1.25rem;
        border-bottom: 1px solid $brand-gray-light;
        color: $brand-gray-medium;
        transition: all 0.3s ease-in-out;

        &:hover {
          transform: translate(1rem, 0px);
          font-weight: 700;
        }
      }
    }

    .top-category {
      transition: all 0.3s ease-in-out;
      font-weight: 500;
      position: relative;
      display: flex;
      justify-content: space-between;
    }

    .material-icons {
      transition: all 0.3s ease-in-out;
    }

    &.selected {
      .top-category {
        font-weight: 700;

        &::after {
          content: "";
          height: 2px;
          background-color: $brand-black;
          position: absolute;
          bottom: 0;
          width: 100%;
          left: 0;
        }

        .material-icons {
          transform: rotate(180deg);
        }
      }

      &:hover {
        .top-category {
          transform: none;
        }
      }
    }

    &:hover {
      .top-category {
        transform: translate(1rem, 0px);
        font-weight: 700;
      }
    }
  }
}
</style>

<style lang="scss">
@import "~@/styles/global.scss";
.filter .vs__dropdown-toggle {
  border-radius: 0;
  border-color: $brand-gray-medium;

  input {
    font-size: $font-sm;
  }
}
.filter .vs__selected-options {
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.filter .vs__dropdown-menu {
  min-width: fit-content;
}
</style>
